import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Spring/FractionsDecimalsAndPercentages/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'FractionsDecimalsAndPercentages',
  field: 'Number',
  weeks: [7, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/1DecimalAndFractionEquivalents" */ './1DecimalAndFractionEquivalents'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/2FractionsAsDivision" */ './2FractionsAsDivision'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/3UnderstandPercentages" */ './3UnderstandPercentages'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/4FractionsToPercentages" */ './4FractionsToPercentages'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/5EquivalentFractionsDecimalsAndPercentages" */ './5EquivalentFractionsDecimalsAndPercentages'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/6OrderFractionsDecimalsAndPercentages" */ './6OrderFractionsDecimalsAndPercentages'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/7PercentageOfAnAmountOneStep" */ './7PercentageOfAnAmountOneStep'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/8PercentageOfAnAmountMultiStep" */ './8PercentageOfAnAmountMultiStep'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/FractionsDecimalsAndPercentages/9PercentagesMissingValues" */ './9PercentagesMissingValues'
        )
    })
  ]
});
export default Block;
